export default __webpack_public_path__ + "static/media/working_with_computer.6835ddc8.svg";